import { useRef } from 'react';

export const useLongPress = (delay = 600) => {
  const timeout = useRef(null);

  const start = (callback) => {
    timeout.current = setTimeout(callback, delay);
  };

  const cancel = () => {
    clearTimeout(timeout.current);
    timeout.current = null;
  };

  return { start, cancel };
};
